import { defineAsyncComponent } from 'vue';

export { useReportsLibraryStore } from './stores/reportsLibrary';

export const reportsMicroFrontends = {
	ReportsFrontPage: defineAsyncComponent(
		() => import('./components/ReportsLibrary/ReportsFrontPage.vue')
	),
	ReportsLibraryButton: defineAsyncComponent(
		() => import('./components/ReportsLibrary/ReportsLibraryButton.vue')
	),
};
